<div class="tabs-container" [ngClass]="styleClass">
  <div
    class="tab"
    *ngFor="let tab of tabs"
    (click)="clicked(tab)"
    [ngClass]="[styleClass, selected === tab ? 'active' : '']">
    {{ tab }}
  </div>
</div>